import React from 'react';

interface SidebarButtonProps {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const SidebarButton: React.FC<SidebarButtonProps> = ({ isActive, onClick, children }) => {
  return (
    <button
      className={`mx-2 rounded-lg px-2 text-left ${isActive ? 'mx-4 bg-gray-200 text-blue-500' : ''}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default SidebarButton;
